import React, { useState,useEffect } from 'react';
import { Container,Card,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
const HostalEventSlider = ({stId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Sliders,setSlider]=useState([])
    useEffect(()=>
    {
        const getDynamicSlider = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"slider/byType/"+stId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                .then(up => up.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                .then(uph => uph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([ups, upsh]) => {
                                    return {
                                        ...e,
                                        ups,
                                        upsh
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].slideImage = (el.ups.length > 0) ? global.config.uploadPath + el.ups[0].up_fname + el.ups[0].up_ext : '';
                            result[i].slideImageHi = (el.upsh.length > 0) ? global.config.uploadPath + el.upsh[0].up_fname + el.upsh[0].up_ext : '';
                        });
                        setSlider(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Slider File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setSlider([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true )
                {
                    console.info('Slider : Result',result);
                }         
            }
            catch (error) 
            {
                console.error('Slider : Error', error.message);
                setLoading(false);
            }
        };
        getDynamicSlider();  
    },[stId])
    const settings = 
    {
        autoplay: true,
        infinite: true,
        dots: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 2 }}, { breakpoint: 768,settings: { slidesToShow: 1 }} ]
    };
    return (
        <Container className='mb-3 mb-md-5'>
            {isLoading ? (
            <div className="slider-container" data-aos="flip-left" data-aos-duration="1500">
                <Slider {...settings}>
                    {[...Array(5)].map((_,index)=>(
                    <div className='p-2 p-md-3' key={index}>
                        <Card className='border-0 bg-success-subtle'>
                            <Card.Body>
                                <Placeholder xs={12} style={{minHeight:"200px"}} />
                            </Card.Body>
                        </Card>
                    </div>
                    ))}
                </Slider>
            </div>
            ) : (
            <div className="slider-container" data-aos="flip-left" data-aos-duration="1000">
                <Slider {...settings}>
                    {Sliders.map((ss, index)=>(
                        ss.slideImage ? (
                        <Card className='border-0 rounded-0 p-2' key={index}>
                            <Card.Body className='bg-success-subtle'>
                                {appLanguage === 'hi' ? 
                                    (
                                        ss.ss_display_en === "1" && ss.slideImageHi 
                                        ? <Card.Img src={ss.slideImageHi} /> 
                                        : ss.slideImageHi 
                                            ? <Card.Img src={ss.slideImageHi} /> 
                                            : <Card.Img src={ss.slideImage} />
                                    ) : (
                                        <Card.Img src={ss.slideImage} />
                                    )
                                }                                
                            </Card.Body>
                        </Card>
                        ) : null                        
                    ))}
                </Slider>
            </div>
            )}
        </Container>
    );
}
export default HostalEventSlider;